import { Brain, Send, Settings, Upload } from "lucide-react";
import { Template } from "./types";
import { CampaignData } from "../../components/types";

  export const steps = [
    {
      id: 1,
      title: "Brief",
      icon: Settings,
      description: "Basic campaign configuration",
    },
    {
      id: 2,
      title: "Details",
      icon: Upload,
      description: "CSV file upload and validation",
    },

    {
      id: 3,
      title: "Messaging",
      icon: Brain,
      description: "Generate personalized messages",
    },

    {
      id: 4,
      title: "Preview and Launch",
      icon: Send,
      description: "Final review and deployment",
    },
  ];

  export const TEMPLATES: Template[] = [
    { id: "1", name: "Seasonal Promo",       type: "Media + Text", preview: "Hi {{1}}! 😊 Our {{2}} is here. Get {{3}}% off with code {{4}}. Shop before {{5}}!" },
    { id: "2", name: "Flash Sale Alert",     type: "Text",         preview: "Hi {{1}}. Our {{2}} is here. Get {{3}}% off with code {{4}}." },
    { id: "3", name: "Win-back offer",       type: "Media + Text", preview: "Hi {{1}}. 😊 Our {{2}} is here." },
    { id: "4", name: "New service offer",    type: "Text",         preview: "Hi {{1}}. Our {{2}} is here. Get {{3}}% off with code {{4}}." },
    { id: "5", name: "Welcome promo",        type: "Text",         preview: "Hi {{1}}. Our {{2}} is here. Get {{3}}% off with code {{4}}." },
    { id: "6", name: "Dussehra Sale Alert",  type: "Media + Text", preview: "Hi {{1}}. 😊 Our {{2}} is here. Get {{3}}% off with code {{4}}." },
    { id: "7", name: "Christmas Sale Alert", type: "Media + Text", preview: "Hi {{1}}. 😊 Our {{2}} is here. Get {{3}}% off with code {{4}}." },
  ];

  // ─────────────────────────────────────────────────────────────
// Props Interface
// ─────────────────────────────────────────────────────────────

export interface MessagingProps {
  campaignData: CampaignData
  setCampaignData: React.Dispatch<React.SetStateAction<CampaignData>>;
  onValidation?: (isValid: boolean) => void;
  onSubmit?: (data: Partial<CampaignData>) => void;
    onBack: () => void;
}

// ─────────────────────────────────────────────────────────────
// Constants & Helper Functions
// ─────────────────────────────────────────────────────────────

export const CUSTOMER_NAME_OPTIONS = ["First_Name", "Last_Name", "Full_Name", "Nickname"];

export function typeBadgeClass(type: Template["type"]) {
  return type === "Text"
    ? "bg-indigo-50 text-indigo-600 border border-indigo-200"
    : "bg-violet-50 text-violet-600 border border-violet-200";
}

export const VARIABLE_COLORS = [
  "bg-amber-100 text-amber-700 border border-amber-300",
  "bg-sky-100 text-sky-700 border border-sky-300",
  "bg-emerald-100 text-emerald-700 border border-emerald-300",
  "bg-rose-100 text-rose-700 border border-rose-300",
  "bg-violet-100 text-violet-700 border border-violet-300",
];
